<template>
  <div class="product-detail-bottom-disabled-bar">
    <div class="sell-status">名额已满</div>
    <row-item type="primary"
              :disabled="disabled"
              @click="handleClick"
    >
      {{ btnText }}
    </row-item>
  </div>
</template>

<script>
  import RowItem from '@/components/YmTabbarItem/Row';
  import { getProductPath, projectJump } from '@/utils';
  import { informMe } from '@/services/app';

  export default {
    name: 'ProductDetailBottomDisabledBar',
    components: {
      RowItem,
    },
    data() {
      return {
        disabled: false,
      };
    },
    props: {
      sell: {
        type: Object,
        required: true,
      },
      product: {
        type: Object,
        required: true,
      },
      startHint: {
        type: String,
        default: '开售',
      },
    },
    computed: {
      btnText() {
        const { sell } = this;
        const { status } = sell;
        if (status === 'goToNextProduct') {
          return '查看下一期';
        }
        return `下期${this.startHint}通知我`;
      },
    },
    methods: {
      async handleInformMe() {
        this.disabled = true;
        await informMe(this.product.id, this.product.type);
        this.disabled = false;
      },
      showNextProduct() {
        const { sell } = this;
        const { nextProductId } = sell;
        if (nextProductId && nextProductId > 0) {
          const { type } = this.product;
          const route = getProductPath(type, nextProductId);
          projectJump(route);
        }
      },
      handleClick() {
        const { sell } = this;
        const { status } = sell;
        if (status === 'goToNextProduct') {
          this.showNextProduct();
          return;
        }
        this.handleInformMe();
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .product-detail-bottom-disabled-bar {
    flex: 1;
    align-self: stretch;
    display: flex;
  }

  .sell-status {
    font-size: @font-size-medium;
    color: @color-text-lighter;
    background-color: @color-gray-lighter;
    padding: 0 (@size-medium * 2);
    display: flex;
    align-items: center;
  }
</style>
